// Redirects /notifications to the first tab the user can access.
// Users with org-settings management land on Rules; queue-view-only users land on Queue.

import { Navigate } from 'react-router-dom';
import { usePermissions } from '@/contexts/PermissionContext';

const NotificationsIndexRedirect = () => {
  const { can, loading } = usePermissions();

  if (loading) return null;

  return <Navigate to={can('admin_manage_org_settings') ? 'rules' : 'queue'} replace />;
};

export default NotificationsIndexRedirect;
